<template>
  <b-modal
    id="edit-customer-modal"
    centered
    hide-footer
    title="Edit Customer"
  >

    <b-form-group label="First Name">
      <b-form-input v-model="first_name" />
    </b-form-group>

    <b-form-group label="Last Name">
      <b-form-input v-model="last_name" />
    </b-form-group>

    <b-form-group label="Phone">
      <b-form-input v-model="phone" />
    </b-form-group>

    <b-form-group label="Email">
      <b-form-input v-model="email" />
    </b-form-group>

    <b-form-group label="State">
      <b-form-select
        v-model="state"
        :options="stateOptions"
      />
    </b-form-group>

    <div class="text-right">
      <b-button variant="primary" @click="submit">
        Edit
      </b-button>
    </div>

  </b-modal>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: {
    customer: Object,
  },

  data() {
    return {
      first_name: "",
      last_name: "",
      phone: "",
      email: "",
      state: null,
      stateOptions: [],
    };
  },

  async mounted() {
    await this.fetchStates();
    this.$nextTick(() => {
      if (this.customer) {
        this.first_name = this.customer.first_name || "";
        this.last_name = this.customer.last_name || "";
        this.phone = this.customer.phone || "";
        this.email = this.customer.email || "";
        this.state = this.customer.state;
      }
    });
  },

  methods: {
    ...mapActions("appData", [
      "updateCustomer",
      "getStates",
    ]),

    async fetchStates() {
      const res = await this.getStates();
      const list = (res.data && res.data.results) ? res.data.results : (Array.isArray(res.data) ? res.data : []);
      this.stateOptions = [
        { value: null, text: "Select state..." },
        ...list.map(s => ({ value: s.id, text: s.name }))
      ];
    },

    async submit() {
      await this.updateCustomer({
        pk: this.customer.id,
        payload: {
          first_name: this.first_name,
          last_name: this.last_name,
          phone: this.phone,
          email: this.email,
          state: this.state,
        },
      });

      this.$bvModal.hide("edit-customer-modal");
      this.$emit("modalClosed");
    },
  },
};
</script>